<template>
  <v-container fluid>
    <ActionBar />

    <div class="page__content--no-items">
      <Form
        :submit="submitForm"
        :status="currentStatus"
        @setCurrentStatus="setCurrentStatus"
      />

      <Footer  :status="currentStatus" @submit="handleSubmit" />
    </div>
  </v-container>
</template>

<script>
import ActionBar from 'components/importNfe/ActionBar'
import Form from 'components/importNfe/Form'
import Footer from 'components/importNfe/Footer'

export default {
  name: 'ImportNfePage',
  components: {
    ActionBar,
    Form,
    Footer
  },
  data () {
    return {
      namespace: 'Views.ImportNfePage',
      currentStatus: null,
      submitForm: false
    }
  },
  methods: {
    setChatPosition (bottom = null, right = null) {
      const chat = document.querySelector('#oloswcdl-root .oloswebchat-main .cta-button')
      if (chat) {
        chat.style.bottom = bottom
        chat.style.right = right
      }
    },

    handleSubmit () {
      this.submitForm = !this.submitForm
    },

    setCurrentStatus (val) {
      if (val) this.currentStatus = val
    }
  },
  mounted () {
    this.setChatPosition('75px', '10px')
  },
  beforeDestroy () {
    this.setChatPosition()
  }
}
</script>

<style lang="scss" scoped>
.page__content--no-items {
  padding-top: 0 !important;

  @media (min-width: 768px) {
    padding-top: 64px !important;
  }
}
</style>
